import { Badge } from "~/components/ui/badge";
import type { RecipeChangeStatus } from "~/types/recipeChange";

const CONFIG: Record<RecipeChangeStatus, { label: string; className: string }> = {
  pending: {
    label: "Pendiente",
    className: "border-amber-200 bg-amber-50 text-amber-700",
  },
  approved: {
    label: "Aprobado",
    className: "border-green-200 bg-green-50 text-green-700",
  },
  rejected: {
    label: "Rechazado",
    className: "border-red-200 bg-red-50 text-red-700",
  },
};

export function RecipeChangeStatusBadge({
  status,
}: {
  status: RecipeChangeStatus;
}) {
  const cfg = CONFIG[status];
  return (
    <Badge variant="outline" className={cfg.className}>
      {cfg.label}
    </Badge>
  );
}
